import React from 'react';
import { homesApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

export default function MyHomes() {
  const { data: homes, loading, error, reload } = useApiData(() => homesApi.list());

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">My Homes</h1>
      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={homes?.length === 0} emptyLabel="No homes yet.">
        <div className="grid md:grid-cols-2 gap-4">
          {homes?.map((h) => (
            <div key={h.id} className="glass rounded-xl p-5">
              <div className="flex items-center justify-between">
                <p className="font-semibold">{h.name}</p>
                {h.is_default && (
                  <span className="text-xs px-2 py-0.5 rounded-full bg-[#00d4ff]/20 text-[#00d4ff]">Default</span>
                )}
              </div>
              {h.address && <p className="text-white/50 text-sm mt-1">{h.address}</p>}
              {h.timezone && <p className="text-white/30 text-xs mt-1">{h.timezone}</p>}
            </div>
          ))}
        </div>
      </StateBlock>
    </div>
  );
}
